import axios from 'axios'
import { apiTimeout, mainWeb } from '../config/net'
import { getCookie } from './cookie'
import Loading from './loading'

let token = getCookie('token') || getCookie('i200_token')
// 开发模式写死token
if (process.env.NODE_ENV === 'development') {
  token = ''
}
const _axios = axios.create({
  timeout: apiTimeout,
  headers: {
    token: token
  }
})

// TODO 如果不需要loading，可以新注册axios实例
const loadingTools = Loading()

// Add a request interceptor
_axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  loadingTools.loading()
  return config
}, function (error) {
  // Do something with request error
  loadingTools.hide()
  return Promise.reject(error)
})

// Add a response interceptor
_axios.interceptors.response.use(function (response) {
  // Do something with response data
  loadingTools.hide()
  return response
}, function (error) {
  // Do something with response error
  loadingTools.hide()
  return Promise.reject(error)
})

function urlFilter (url) {
  return url.indexOf(mainWeb) !== -1 || url.indexOf('/wumao/') !== -1
}

export default {
  get (url, query) {
    // session.get
    /* eslint-disable */
    if (process.env.NODE_ENV === 'development') { // 开发模式下走本地请求
      return _axios.get(url, query)
    } else {
      if (urlFilter(url)) {
        return _axios.get(url, query)
      } else {
        return new Promise(resolve => {
          loadingTools.loading()
          $fe_bridge.session.send('get', url, {}, res => {
            loadingTools.hide()
            resolve({ data: res })
          })
        })
      }
    }
    /* eslint-enable */
  },
  post (url, data) {
    // session.post
    /* eslint-disable */
    console.log(url)
    if (url.indexOf(mainWeb) !== -1) {
      return _axios.post(url, data)
    } else {
      return new Promise(resolve => {
        loadingTools.loading()
        $fe_bridge.session.send('post', url, data, res => {
          loadingTools.hide()
          resolve({ data: res })
        })
      })
    }
    /* eslint-enable */
  },
  delete (url) {
    return _axios.delete(url)
  },
  put (url, data) {
    return _axios.put(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/tools/api-tools.js